"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveScopeWithSchema = exports.resolveScope = void 0;
const types_1 = require("../../types");
const resolveCustomFieldType_1 = require("./resolveCustomFieldType");
const utils_1 = require("./utils");
const resolveScope = (metaExpression, options) => {
    var _a, _b;
    const answerCustomField = (0, utils_1.getSafeValue)(options.object, (_b = (_a = metaExpression.custom_field3) !== null && _a !== void 0 ? _a : metaExpression.custom_field2) !== null && _b !== void 0 ? _b : metaExpression.custom_field1);
    if (answerCustomField !== undefined) {
        return (0, utils_1.getMeResultCustomFieldResult)(answerCustomField);
    }
    const answerField = (0, utils_1.getSafeValue)(options.object, metaExpression.field);
    if (answerField !== undefined) {
        return (0, utils_1.getMeResultFieldResult)(answerField);
    }
    if (metaExpression.default_value)
        return metaExpression.custom_field1 ||
            metaExpression.custom_field2 ||
            metaExpression.custom_field3
            ? (0, utils_1.getMeResultCustomFieldResult)(metaExpression.default_value)
            : (0, utils_1.getMeResultFieldResult)(metaExpression.default_value);
    return (0, utils_1.getMeResultNoResult)();
};
exports.resolveScope = resolveScope;
const resolveScopeWithSchema = (metaExpression, options) => {
    const { schema, object } = options;
    if (!schema || !object)
        return (0, utils_1.getMeResultNoResult)();
    const customField = schema.find((q) => q.tag == metaExpression.custom_field1);
    const fieldType = customField === null || customField === void 0 ? void 0 : customField.type;
    if (metaExpression.hasOwnProperty("custom_field1")) {
        if (fieldType == types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE) {
            return (0, resolveCustomFieldType_1.resolveCustomFieldTypeSingleChoice)(metaExpression, options);
        }
        if (fieldType == types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE) {
            return (0, resolveCustomFieldType_1.resolveCustomFieldTypeMultipleChoice)(metaExpression, options);
        }
        if (fieldType == types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST) {
            return (0, resolveCustomFieldType_1.resolveCustomFieldTypeSCOL)(metaExpression, options);
        }
        if (fieldType == types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE_ON_LIST) {
            // do nothing special. use general resolution.
        }
        if (fieldType == types_1.CUSTOM_FIELD_TYPE.MATRIX_ON_LIST) {
            return (0, resolveCustomFieldType_1.resolveCustomFieldTypeMXOL)(metaExpression, options);
        }
        if (fieldType == types_1.CUSTOM_FIELD_TYPE.DATE_PICKER) {
            return (0, resolveCustomFieldType_1.resolveCustomFieldTypeDatePicker)(metaExpression, options);
        }
        if (fieldType == types_1.CUSTOM_FIELD_TYPE.PICTURE ||
            fieldType == types_1.CUSTOM_FIELD_TYPE.UPLOAD_FILE) {
            return (0, resolveCustomFieldType_1.resolveCustomFieldTypePictureOrFile)(metaExpression, options);
        }
        if (fieldType == types_1.CUSTOM_FIELD_TYPE.GPS) {
            return (0, resolveCustomFieldType_1.resolveCustomFieldTypeLocation)(metaExpression, options);
        }
    }
    // if no customfield1 or is not resolve, resolve by parent.
    return (0, exports.resolveScope)(metaExpression, options);
};
exports.resolveScopeWithSchema = resolveScopeWithSchema;
